module.exports = "input {\n  width: 100%; }\n"